const processCuratedPlaylist = (feedBlock) => {
  return {
    label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
    ...(feedBlock || {}),
    extraBlockinfo: {
      ...(feedBlock.extraBlockInfo || {})
    }
  };
};

export default processCuratedPlaylist;
